import styled from 'styled-components';
import { Button, FormText, Col } from 'reactstrap';

export const StyledCloseButton = styled(Button)`
  border: 1px solid #dfe3ec;
  box-sizing: border-box;
  border-radius: 4px;
  margin-left: 16px;
`;

export const StyledAllowedMediaTypes = styled(FormText)`
  font-size: 12px;
  line-height: 16px;
  color: #767676;
  width: 100%;
  margin-top: 35px;
  white-space: pre-line;
`;

// overriding the default padding
export const StyledFileInputCol = styled(Col)`
  padding-right: 0;
`;

export const StyledAllowedMediaCol = styled(Col)`
  padding-left: 0;
`;

export const StyledInput = styled.input`
  max-width: 300px;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
`;
